module.exports = __webpack_public_path__ + "img/pr-5.44975e25.png";